import React from 'react';
import Form from './Form';

const Login = () => {
    return (
        <Form />
    );
}

export default Login;
